// func assíncrona que faz fetch de todas as tarefas da API
const endpointTodos = 'https://jsonplaceholder.typicode.com/todos';
export async function fetchTodos() {
  const response = await fetch(endpointTodos);
  const todos = await response.json();
  return todos;
}
// função assíncrona que faz fetch de todas as fotos da API
const endpointPhotos = 'https://jsonplaceholder.typicode.com/photos';
export async function fetchPhotos() {
  const response = await fetch(endpointPhotos);
  const photos = await response.json();
  return photos;
}
// função assíncrona que faz um fetch de todos os albuns da api
const endpointAlbuns = 'https://jsonplaceholder.typicode.com/albums';
export async function fetchAlbuns() {
  const response = fetch(endpointAlbuns);
  const albuns = await (await response).json();
  return albuns;
}

// função assíncrona que faz um fetch de todos os comentários da api
const endpointComments = 'https://jsonplaceholder.typicode.com/comments';
export async function fetchComments() {
  const response = fetch(endpointComments);
  const comments = await (await response).json();
  return comments;
}

// função assíncrona que faz um fetch de todos os posts da API
const endpointPosts = 'https://jsonplaceholder.typicode.com/posts';
export async function fetchPosts() {
  const response = await fetch(endpointPosts);
  const posts = await response.json();
  return posts;
}
// função assíncrona que faz um fetch de todos os usuários a API
// utilizarei para correlacionar com os posts, comments e to-dos.
const endpointUsers = 'https://jsonplaceholder.typicode.com/users';
export async function fetchUsers() {
  const response = await fetch(endpointUsers);
  const users = await response.json();
  return users;
}
